import React, { useState } from 'react';
import { Menu, X, Phone, Mail, MapPin } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Courses', path: '/courses' },
    { name: 'Faculty', path: '/faculty' },
    { name: 'Gallery', path: '/gallery' },
   
    { name: 'Contact', path: '/contact' },
    { name: 'TutorWave', path: '/tutorwave' } 
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-nav">
      <div className="container mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/sxgus9c0_The%20LIGHTHOUSE%20Logo.jpg" 
            alt="The Lighthouse Coaching Institute" 
            className="h-12 w-12 object-contain"
          />
          <div className="flex flex-col">
            <span className="text-xl font-semibold text-[var(--text-primary)]">
              The Lighthouse
            </span>
            <span className="text-xs font-mono uppercase tracking-wider text-[var(--text-muted)]">
              Coaching Institute
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors hover:text-[var(--text-primary)] ${
                isActive(link.path)
                  ? 'text-[var(--text-primary)] font-semibold'
                  : 'text-[var(--text-secondary)]'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Contact Info - Desktop */}
        <div className="hidden lg:flex items-center gap-4">
          <div className="flex flex-col gap-1">
            <a
              href="tel:+917004929531"
              className="flex items-center gap-2 text-xs text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
            >
              <Phone size={14} />
              <span className="font-mono">+91 70049 29531</span>
            </a>
          </div>
          <Link to="/contact" className="btn-primary">
            Enroll Now
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="lg:hidden p-2 text-[var(--text-primary)]"
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-[var(--bg-overlay)] backdrop-blur-lg border-t border-[var(--border-light)] shadow-lg">
          <nav className="container mx-auto py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-base font-medium py-2 transition-colors ${
                  isActive(link.path)
                    ? 'text-[var(--text-primary)] font-semibold'
                    : 'text-[var(--text-secondary)]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="flex flex-col gap-3 pt-4 border-t border-[var(--border-light)]">
              <a
                href="tel:+917004929531"
                className="flex items-center gap-2 text-sm text-[var(--text-secondary)]"
              >
                <Phone size={16} />
                <span className="font-mono">+91 70049 29531</span>
              </a>
              <Link
                to="/contact"
                className="btn-primary text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                
                Enroll Now
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
